import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';


@Injectable()
export class TimebankService {
    userUrl = 'api/timebank';

    httpOptions = {
        headers: new HttpHeaders({
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
        })
    };

    constructor(
        private httpClient: HttpClient,
    ) {
    }

    getTimeBanks(): Observable<any> {
        return this.httpClient.get(this.userUrl, this.httpOptions);
    }

}
